import { render, staticRenderFns } from "./WebFormTab.vue?vue&type=template&id=2bb100f9&"
import script from "./WebFormTab.vue?vue&type=script&lang=js&"
export * from "./WebFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports